// HIRANYA — Cart Drawer Quantity Control
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".cart-qty-btn");
  if (!btn) return;

  const drawer = document.querySelector("#Cart-Drawer, .cart-drawer");
  if (!drawer) return;

  const input = btn.parentNode.querySelector("input[type='number']");
  let quantity = parseInt(input.value);

  if (btn.classList.contains("plus")) quantity++;
  else if (btn.classList.contains("minus")) quantity = Math.max(1, quantity - 1);

  input.value = quantity;
  const minusBtn = btn.parentNode.querySelector(".minus");
  minusBtn.disabled = quantity <= 1;

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: btn.dataset.line, quantity: quantity })
  })
    .then(r => r.json())
    .then(() => {
      fetch(window.Shopify.routes.root + 'cart?view=drawer')
        .then(res => res.text())
        .then(html => {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const newDrawer = temp.querySelector('#Cart-Drawer, .cart-drawer');
          if (newDrawer && drawer) {
  drawer.innerHTML = newDrawer.innerHTML;

  // Animate subtotal fade
  const subtotal = drawer.querySelector(".mini-cart__total .amount");
  if (subtotal) {
    subtotal.style.transition = "opacity 0.3s";
    subtotal.style.opacity = "0.2";
    setTimeout(() => (subtotal.style.opacity = "1"), 150);
  }
}

        });
    });
});
